import { Location } from '@angular/common';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RtLocation extends Location {
  public go$ = new Subject<string>();

  public go(path: string, query?: string, state?: any) {
    this.go$.next(path);
    return super.go(path, query, state);
  }
}
